import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "custom-form__head" }
const _hoisted_2 = { class: "custom-form__info" }
const _hoisted_3 = {
  key: 0,
  class: "custom-form__label"
}
const _hoisted_4 = {
  key: 0,
  class: "custom-form__required"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["custom-form__inputBlock", `custom-form__inputBlock_${_ctx.mode}`])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.title)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
              _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
              (_ctx.required)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, "*"))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.tooltipText)
          ? (_openBlock(), _createBlock(_component_Tooltip, { key: 1 }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.tooltipText), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      (_ctx.isButtonVisible)
        ? (_openBlock(), _createBlock(_component_ButtonComponent, {
            key: 0,
            mod: "only-blue-text",
            onClick: _ctx.handleButtonClick,
            class: "custom-form__button",
            buttonType: "button"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.buttonText), 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 2))
}